import React from 'react';
import {ReactNode, useMemo} from 'react';

const useFilterNames = (children: ReactNode) =>
    useMemo(() => {
        const extractNames = (children: ReactNode): string[] => {
            let names: string[] = [];

            React.Children.forEach(children, (child) => {
                if (React.isValidElement(child)) {
                    if (child.props.name) {
                        names.push(child.props.name);
                    }

                    // Recursively check nested children
                    if (child.props.children) {
                        names = names.concat(
                            extractNames(child.props.children),
                        );
                    }
                }
            });

            return names;
        };

        return extractNames(children);
    }, [children]);

export default useFilterNames;
